import { render } from "./CTIDetail.vue?vue&type=template&id=0c07b3f0"
import script from "./CTIDetail.vue?vue&type=script&lang=js"
export * from "./CTIDetail.vue?vue&type=script&lang=js"

import "./CTIDetail.vue?vue&type=style&index=0&id=0c07b3f0&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__